import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import * as authUtils from '../../auth-utils';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-contact-no',
  templateUrl: './contact-no.component.html',
  styleUrls: ['../../auth-connect/auth-connect.component.scss', './contact-no.component.scss']
})
export class ContactNoComponent {
  @Input() userProfile: any;
  @Output() userProfileChange = new EventEmitter<any>();
  @Input() page!: string;
  @Input() showFormNavigationBtn = true;
  @Output() signUpPageCount = new EventEmitter<number>();
  @ViewChild('contactNoForm') contactNoForm !: NgForm
  pdfSource: any;
  signUpCount!: number;
  elementName: string = 'sms';

  formatPhoneNumber(event: any) {
    this.userProfile.phone = authUtils.formatPhoneNumber(event);
  }

}
